import { Component } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ExtractsService } from '../../services/extracts-service/extracts.service';
import { DatePipe, CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { DropdownModule } from 'primeng/dropdown';
interface DoItem {
  name: string;
  modele: string;
  type: string;
}

interface DropdownDoItem {
  label: string;
  value: string;
}

@Component({
  selector: 'app-extract-facturation',
  standalone: true,
  imports: [
    BreadcrumbModule,
    FormsModule,
    RadioButtonModule,
    InputTextModule,
    ListboxModule,
    CommonModule,
    ToastModule,
    ButtonModule,
    TableModule,
    DatePickerModule,
    DropdownModule,
  ],
  providers: [DatePipe, MessageService],
  templateUrl: './extract-facturation.component.html',
  styleUrl: './extract-facturation.component.scss'
})
export class ExtractFacturationComponent {
  breadcrumbHome = { icon: 'pi pi-database', to: 'extract-facturation' };
  breadcrumbItems = [{ label: 'Rapports Facturation' }];

  radioValue: string | null = null;
  doList: DoItem[] = [];
  filteredDoList: DropdownDoItem[] = [];
  selectedDo: DropdownDoItem = { label: 'Tous les DOs', value: 'all' };

  selectedMonth: Date;
  currentMonth: Date;
  minMonth: Date;
  maxMonth: Date;

  isLoading: boolean = false;
  previewData: any[] = [];
  previewColumns: string[] = [];
  showPreviewTable: boolean = false;
  loadingPreview: boolean = false;

  facturationTypes = [
    { label: 'Interactions', value: 'interaction' },
    { label: 'Dossiers', value: 'dossier' },
    { label: 'Dossiers et interactions', value: 'interaction et dossier' }
  ];
  doSearchText: string | undefined;

  constructor(private extractsService: ExtractsService, private messageService: MessageService) {
    // Initialisation des dates
    this.currentMonth = new Date();
    this.currentMonth.setHours(0, 0, 0, 0);

    // Mois minimum: janvier de l'année en cours
    this.minMonth = new Date(2024, 0, 1);

    // Mois maximum: mois précédent (exclut le mois courant)
    this.maxMonth = new Date(this.currentMonth);
    this.maxMonth.setMonth(this.currentMonth.getMonth() - 1);

    // Initialiser avec le mois précédent par défaut
    this.selectedMonth = new Date(this.maxMonth);
  }

  ngOnInit() {
    this.loadDoListFromAPI();
  }

async onTypeChange(): Promise<void> {
  this.selectedDo = { label: 'Tous les DOs', value: 'all' };
  this.resetPreview();
  await this.loadDoListFromAPI(); // Nouvelle méthode
}

  onMonthChange() {
    if (this.validateMonth()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Mois invalide',
        detail: 'Le mois en cours ne peut pas être sélectionné'
      });
      this.selectedMonth = new Date(this.maxMonth);
      return;
    }
    this.loadPreviewData();
  }

  validateMonth(): boolean {
    if (!this.selectedMonth) return true;

    const selected = new Date(this.selectedMonth);
    const current = new Date();

    return selected.getMonth() === current.getMonth() &&
           selected.getFullYear() === current.getFullYear();
  }

public async loadDoListFromAPI(): Promise<void> {
  if (!this.radioValue) {
    this.filteredDoList = [{ label: 'Tous les DOs', value: 'all' }];
    return;
  }

  this.isLoading = true;

  try {
    const doNames = await this.extractsService.get_do_facturation(this.radioValue).toPromise();

    if (Array.isArray(doNames)) {
      this.filteredDoList = [
        { label: 'Tous les DOs', value: 'all' },
        ...doNames.map(name => ({ label: name, value: name }))
      ];
    } else {
      this.filteredDoList = [{ label: 'Tous les DOs', value: 'all' }];
    }
  } catch (error) {
    console.error('Erreur lors du chargement des DOs selon type', error);
    this.messageService.add({
      severity: 'error',
      summary: 'Erreur',
      detail: 'Impossible de charger les DOs pour ce type de facturation'
    });
    this.filteredDoList = [{ label: 'Tous les DOs', value: 'all' }];
  } finally {
    this.isLoading = false;
  }
}


  filterDoList() {
    const searchText = (this.doSearchText || '').toLowerCase().trim();

    let filteredByType = this.doList;
    if (this.radioValue) {
      filteredByType = this.doList.filter(item =>
        item.type.toLowerCase() === this.radioValue?.toLowerCase()
      );
    }

    let filtered = filteredByType
      .filter(item =>
        item.name.toLowerCase().includes(searchText) ||
        item.modele.toLowerCase().includes(searchText)
      )
      .map(item => ({ label: item.name, value: item.name }));

    this.filteredDoList = [
      { label: 'Tous les DOs', value: 'all' },
      ...filtered
    ];
  }

  loadPreviewData() {
    if (!this.radioValue || !this.selectedMonth || this.validateMonth()) {
      this.resetPreview();
      return;
    }

    this.loadingPreview = true;
    this.showPreviewTable = false;

    const mois = this.selectedMonth.getMonth() + 1;
    const annee = this.selectedMonth.getFullYear();
    const doValue = this.selectedDo.value;

    this.extractsService.preview_data_by_TypeFactu(
      doValue,
      this.radioValue,
      mois

    ).subscribe({
      next: (data) => {
        if (data && Array.isArray(data)) {
          this.previewData = data;
          if (data.length > 0) {
            this.previewColumns = Object.keys(data[0]);
          }
          this.showPreviewTable = true;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aucune donnée',
            detail: 'Aucune donnée disponible pour cette sélection'
          });
        }
        this.loadingPreview = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement de la prévisualisation', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de charger les données de prévisualisation'
        });
        this.loadingPreview = false;
      }
    });
  }

  exportClientReport() {
    if (!this.radioValue || !this.selectedMonth || this.validateMonth()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sélection incomplète',
        detail: 'Veuillez sélectionner un type de facturation et un mois valide'
      });
      return;
    }

    this.isLoading = true;
    const mois = this.selectedMonth.getMonth() + 1;
    const annee = this.selectedMonth.getFullYear();
    const doValue = this.selectedDo.value;
    const doLabel = this.selectedDo.label;

    this.extractsService.get_data_by_TypeFactu(
      doValue,
      this.radioValue,
      mois,
      true
    ).subscribe({
      next: (blob) => {
        const downloadLink = document.createElement('a');
        const url = window.URL.createObjectURL(blob);

        downloadLink.href = url;

        const fileNameDoPart = doValue === 'all' ? 'tous_les_dos' : doLabel || doValue;
        downloadLink.download = `export_${fileNameDoPart}_${this.radioValue}_${mois}_${annee}.csv`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(downloadLink);

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de l\'export', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: error.error?.message || 'Une erreur est survenue lors de l\'export'
        });
        this.isLoading = false;
      }
    });
  }

  private resetPreview() {
    this.previewData = [];
    this.previewColumns = [];
    this.showPreviewTable = false;
  }
}
